import InputPhone from "../../../components/Inputs/InputPhone";
import SearchSelect from "../../../components/Inputs/SearchSelect";

export default function InputForm (props: any){
    return(
        <div style={{...props.containerStyle, display: 'flex', flexDirection: 'column', width: '100%'}} className='m input-label'>
            {props.type !== 'checkbox' && <label htmlFor={props.name} className="field-label">{props.label}
            {props.required &&
                <span style={{color: 'red'}}>*</span>            
            }
            </label>}
            {(props.type !== 'select' && props.type !== 'phone' && props.type !== 'checkbox') &&
            <div style={{display: 'flex'}}>
                {props.leftIcon &&
                    <img src = {props.leftIcon} className="cf-input-icon"/>
                }
                <input
                    id={props.name}
                    autoComplete={props.autoComplete ?? 'off'}
                    type={props.type}
                    value={props.value}
                    onChange={props.onChange}
                    name={props.name}
                    maxLength={props.maxLength || 50}
                    placeholder={props.placeholder}
                    disabled={props.disabled}
                    className={props.inputClassname ?? "text-field w-input"}
                    onBlur={props.onBlur}     
                    accept={props.accept}             
                />
            </div>
            }
            {props.type === 'select' &&
                <SearchSelect
                    enableCreate = {props.enableCreate ?? false} 
                    data = {props.options}
                    keyNameValue = {props.keyNameValue} 
                    keyNameText = {props.keyNameText}
                    placeholder = {props.placeholder} 
                    value = {props.value} 
                    onChange = {props.onChange} 
                    name = {props.name} 
                    disabled = {props.disabled}
                    defaultValue={props.defaultValue}
                    placement={props.placement}
                    onBlur={props.onBlur}
                    maxMenuHeight={props.maxMenuHeight}
                />
            }
            {props.type === 'phone' &&
                <InputPhone 
                    className = 'text-field w-input' 
                    value = {props.value} 
                    onChange = {props.onChange} 
                    onBlur = {props.onBlur} 
                    name = {props.name} 
                    disabled = {props.disabled}
                />
            }
            {props.type === 'checkbox' &&
                <label className='container-checkbox m'>
                    {props.label}
                    <input
                        autoFocus
                        type='checkbox'
                        name={props.name}
                        checked={props.value}
                        onChange={props.onChange}
                        disabled={props.disabled}
                    />
                    <span className='checkmark-checkbox'></span>
                </label>
            }
            {props.error &&
                <p className='alert s'>{props.error}</p>
            }
            {props.helperText &&
                <div style={{maxWidth: 380, fontSize: 11}} className='alert-info-text'>
                    {props.helperText}
                </div>
            }
        </div>
    )
}